export default __webpack_public_path__ + "static/media/hrm1.b045dedc.svg";